import { MenuItem } from "@mui/material";
import { convertDateString } from "../../../../../../../../utils/dateFormat";
import { getFirstTwoParts } from ".";

export const mrqRegisterColumns = ({
  tasks,
  tasksGroups,
  groupedTasks,
  createRowErrors,
}) => [
  {
    accessorKey: "plantName",
    header: "plant Name",
    muiEditTextFieldProps: {
      disabled: true,
    },
  },
  {
    accessorKey: "wbsGroup",
    header: "WBS Group",
    size: 20,
    Cell: ({ row }) => {
      const wbsGroup = tasks.find((t) =>
        t.taskCode.startsWith(getFirstTwoParts(row.original.wbs) + "-"),
      )?.taskCode;
      return wbsGroup || "";
    },
    muiEditTextFieldProps: ({ row }) => ({
      children: tasksGroups.map((task) => (
        <MenuItem key={task} value={task}>
          {task}
        </MenuItem>
      )),
      select: true,
      error: createRowErrors[row.id]?.wbsGroup,
      helperText: createRowErrors[row.id]?.wbsGroup
        ? "This field is required"
        : "",
    }),
  },
  {
    accessorKey: "wbs",
    header: "WBS Code/Task",
    size: 20,
    muiEditTextFieldProps: ({ row }) => {
      const selectedWbsGroup =
        row._valuesCache.wbsGroup ?? row.original.wbsGroup ?? "";
      const groupCode = selectedWbsGroup.split("-")?.[0];
      const filteredTasks = groupedTasks[groupCode] || [];
      const subTasks = filteredTasks.map((t) => {
        const parts = t.taskCode.split("-");

        if (parts[0]?.split(".").length > 2) {
          return { ...t, taskCode: parts[0] + "-" + t.task };
        } else return "";
      });

      return {
        select: true,
        value: row._valuesCache.wbs ?? row.original.wbs ?? "",
        disabled: !selectedWbsGroup,
        children: subTasks.map((task) => (
          <MenuItem key={task.id} value={`${task.taskCode}`}>
            {`${task.taskCode}`}
          </MenuItem>
        )),
        error: createRowErrors[row.id]?.wbs,
        helperText: createRowErrors[row.id]?.wbs
          ? "This field is required"
          : "",
      };
    },
  },
  {
    accessorKey: "mrqNumber",
    header: "Mrq Number",
    muiEditTextFieldProps: ({ row }) => ({
      error: createRowErrors[row.id]?.mrqNumber,
      helperText: createRowErrors[row.id]?.mrqNumber
        ? "This field is required"
        : "",
    }),
  },
  {
    accessorKey: "rev",
    header: "Revision",
    size: 10,
    muiEditTextFieldProps: ({ row }) => ({
      error: createRowErrors[row.id]?.rev,
      helperText: createRowErrors[row.id]?.rev ? "This field is required" : "",
    }),
  },
  {
    accessorKey: "title",
    header: "Title",
    muiEditTextFieldProps: ({ row }) => ({
      error: createRowErrors[row.id]?.title,
      helperText: createRowErrors[row.id]?.title
        ? "This field is required"
        : "",
    }),
  },
  {
    accessorKey: "mrqDate",
    header: "Date",
    size: 20,
    Cell: ({ row }) => {
      return convertDateString(row.original.mrqDate);
    },

    muiEditTextFieldProps: ({ row }) => ({
      type: "date",
      error: createRowErrors[row.id]?.mrqDate,
      helperText: createRowErrors[row.id]?.mrqDate
        ? "This field is required"
        : "",
    }),
  },
  {
    accessorKey: "materialsNumber",
    header: "Materials",
    size: 20,
    enableEditing: false,
    Cell: ({ row }) =>
      row.original.mrqMaterials?.length || "No Consolidated Materials Yet.",
  },
  {
    accessorKey: "budgetedCost",
    header: "Budgeted Cost($)",
    size: 20,
    enableEditing: false,
    Cell: ({ row }) => "",
  },
];
